var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"8930d02d2afa3c87f3670270d675782dbcf14998"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";

Sentry.init({
  enabled: process.env.NODE_ENV === "production" && process.env.PREVIEW === "1",
  dsn: "https://52ad3df96bb2450db58ee8b936c623f0@o1224454.ingest.sentry.io/6509877",
  tracesSampleRate: 0.1,
  ignoreErrors: [/ResizeObserver loop/],
});
